
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import AddCustomer from "../components/addCustomer";
import Footer from "../components/footer";

function AddCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < AddCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default AddCustomerPage;